import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WizardImportModule } from '@barthauer/abc/interfaces/core/wizards/import';
import { AbcUiComponentsModule } from '@barthauer/abc/ui-components';
import { AbcDropDownBoxComponent } from '../../../../../../../../abc/ui-components/src/lib/core/src/abc-drop-down-box/abc-drop-down-box.component';
import { _AbcFileUploaderComponent } from '../../../../../../../../abc/ui-components/src/lib/core/src/abc-file-uploader/abc-file-uploader.component';
import { AbcTextBoxComponent } from '../../../../../../../../abc/ui-components/src/lib/core/src/abc-text-box/abc-text-box.component';
import { AsciiImportComponent } from './ascii-import.component';
import { AsciiImportService } from './ascii-import.service';
import { SettingSelectionPageComponent } from './pages/setting-selection-page/setting-selection-page.component';
import { SettingShapeselectionPageComponent } from './pages/setting-shapeselection-page/setting-shapeselection-page.component';

@NgModule({
  declarations: [AsciiImportComponent, SettingSelectionPageComponent, SettingShapeselectionPageComponent],
  providers: [AsciiImportService],
  imports: [
    CommonModule,
    WizardImportModule,
    AbcUiComponentsModule,
    AbcTextBoxComponent,
    AbcDropDownBoxComponent,
    _AbcFileUploaderComponent,
  ],
})
export class BasysInterfacesCommonAsciiWizardsImportModule {}
